export const SortOption = {
    Alphabetical: 'alphabetical',
    Created: 'created',
    Default: 'default',
    Draft: 'draft',
    Featured: 'featured',
    HighPrice: 'highPrice',
    InvalidLink: 'invalidLink',
    LowPrice: 'lowPrice',
    New: 'new',
    NewlyCreated: 'newlyCreated',
    Popular: 'popular',
    Trending: 'trending',
    Uncategorised: 'uncategorised',
    Updated: 'updated',
} as const;

export type SortOption = (typeof SortOption)[keyof typeof SortOption];

export function validateSortOption(value: string): SortOption | undefined {
    return Object.values(SortOption).includes(value as SortOption)
        ? (value as SortOption)
        : undefined;
}
